import { KatsomoError } from '@livekatsomo/custom-errors';
import { VideoPlayerComponentProps } from '@livekatsomo/types';
import Fade from '@mui/material/Fade';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import { PlayerComponents } from '../PlayerComponents/PlayerComponents';

/**
 * Props for the VideoPlayer component.
 */
export interface VideoPlayerProps extends VideoPlayerComponentProps {
  className?: string;
}

/**
 * Renders a video player component based on the given stream type.
 */
export function VideoPlayer({ type, className, ...props }: VideoPlayerProps) {
  const Player = PlayerComponents[type];

  if (!Player) {
    throw new KatsomoError(`No player configured for stream type: ${type}`);
  }

  return (
    <TransitionGroup
      component="div"
      style={
        {
          // position: 'relative',
          // width: '100%',
          // height: '100%',
          // aspectRatio: '16/9',
          // display: 'flex',
          // flexDirection: 'column',
          // alignItems: 'center',
          // justifyContent: 'center',
          // marginTop: 'auto',
          // marginBottom: 'auto',
        }
      }
    >
      <Fade
        key={props.source}
        in={true}
        timeout={2000}
        style={{
          position: 'absolute',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className={className}>
          <Player {...props} />
        </div>
      </Fade>
    </TransitionGroup>
  );
}
